import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Col, Row } from "shards-react";
import "./SubAdminDetails.css";
import { app } from "../../../firebase";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Charts from "react-apexcharts";
import { UsersContext } from "../../../providers/Users";
import { httpsCallable, getFunctions } from "firebase/functions";
import Table from "react-bootstrap/Table";

function StudentTestsChart({ scheduledTests, user }) {
  const cloudFunctions = getFunctions(app, "europe-west3");
  const {
    calculatingTestReadingImprovmentForCharts,
    readingChainDataForChart,
    getUserAnswersFromSQL,
    vTestImporvingResultsForChart,
    usersVergenceTestResultsForCharts,
    ansrDatesForChart
  } = useContext(UsersContext);
  const [readingSpeedTestScores, setReadingSpeedTestScores] = useState(null);
  const [testScoresForChart, setTestScoresForChart] = useState([]);
  const moment = require("moment");
  const testChartRef = useRef(null);
  const [chartSeries, setChartSeries] = useState(null);

  const opt = {
    chart: {
      stacked: false
    },
    plotOptions: {
      bar: {
        columnWidth: "20%"
      }
    },
    colors: ["#FF1654", "#247BA0", "#ffb400", "#d600ff"],
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: [4, 4, 4, 4]
    },
    xaxis: {
      type: "datetime",
      tickAmount: 12,
      labels: {
        hideOverlappingLabels: true,
        showDuplicates: false,
        formatter: function(val, timestamp, opts) {
          const weekNumber = moment(val).isoWeek();
          return `w${weekNumber}`;
        }
      }
    },
    yaxis: {
      labels: {
        formatter: function(value, index) {
          return `${value}%`;
        }
      },
      tickAmount: 30
    },
    markers: {
      size: 4
    },
    tooltip: {
      enabled: true,
      enabledOnSeries: undefined,
      y: {
        title: {
          formatter: seriesName => seriesName
        }
      },
      x: {
        formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
          return moment(value).format("DD-MMM-YY");
        }
      }
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: false
        }
      }
    },
    legend: {
      itemMargin: {
        vertical: 20
      }
    }
  };

  useEffect(() => {
    getTestsForAssignedUsers();
  }, [user]);

  useEffect(() => {
    if (readingSpeedTestScores) {
      calculatingTestReadingImprovmentForCharts(
        readingSpeedTestScores.userId,
        readingSpeedTestScores.rsData
      );
    }
  }, [readingSpeedTestScores]);

  useEffect(() => {
    formatDataSeries(
      readingChainDataForChart,
      testScoresForChart,
      vTestImporvingResultsForChart,
      ansrDatesForChart
    );
  }, [readingChainDataForChart, vTestImporvingResultsForChart]);

  const getTestsForAssignedUsers = async () => {
    let vData = [];
    getProprietaryReadingSpeedData(user.Email, user.uid, user.FirstName);
    const vt = await getUserAnswersFromSQL(user.uid);
    if(vt){
      vData.push({ userId: user.uid, data: vt });
      const filteredVData = vData.filter(
        (test, index, self) =>
          index === self.findIndex(t => t.userId === test.userId)
      );
      filteredVData.forEach((elm, indx) => {
        usersVergenceTestResultsForCharts(elm.data, elm.userId);
      });
    }
  };
  const getProprietaryReadingSpeedData = (email, userId, name) => {
    const getUserResults = httpsCallable(
      cloudFunctions,
      "getUserReadingTestsResults"
    );

    getUserResults({ email })
      .then(response => {
        if (response.data.length > 0) {
          setReadingSpeedTestScores({ userId, rsData: response.data });
          setTestScoresForChart(prev => [
            ...prev,
            { userId, name, scoreData: response.data }
          ]);
        }
      })
      .catch(error => {
        console.log("Error fetching user results", error);
      });
  };

  const formatDataSeries = (tests, results, vTest, vDates) => {
    let formattedTest = tests.map(item => {
      let transposedScore = [];
      if (item.score[0] !== undefined) {
        for (let i = 0; i < item.score[0].length; i++) {
          transposedScore.push(item.score.map(row => row[i]));
        }
      }
      return { userId: item.userId, score: transposedScore };
    });
    let userData;
    for (let i = 0; i < results.length; i++) {
      let userTestData = results[i];
      let userFormattedData = formattedTest.find(
        data => data.userId === userTestData.userId
      );
      userData = {
        name: userTestData.name,
        userId: userTestData.userId,
        testsScore: userTestData.scoreData.map(score => ({
          letters: score.letters_score,
          words: score.words_score,
          sentences: score.sentences_score
        })),
        tests: [
          {
            name: "Letters Test",
            data: userTestData.scoreData.map((score, index) => [
              moment(score.date).format("DD-MMM-YY"),
              userFormattedData.score.length > 1
                ? userFormattedData.score[index][0]
                : 0
            ])
          },
          {
            name: "Words Test",
            data: userTestData.scoreData.map((score, index) => [
              moment(score.date).format("DD-MMM-YY"),
              userFormattedData.score.length > 1
                ? userFormattedData.score[index][1]
                : 0
            ])
          },
          {
            name: "Sentences Test",
            data: userTestData.scoreData.map((score, index) => [
              moment(score.date).format("DD-MMM-YY"),
              userFormattedData.score.length > 1
                ? userFormattedData.score[index][2]
                : 0
            ])
          }
        ]
      };
      let mapped = [];
      const mappedVergenceData = vDates.map(doneOn => {
        const result = vTest.find(res => res.userId === doneOn.userId);
        mapped = doneOn.dates.map((date, index) => [
          date,
          result !== undefined ? result.data[index] : 0
        ]);
        return { userId: doneOn.userId, data: mapped };
      });
      let userVergenceData = mappedVergenceData.find(
        data => data.userId === userData.userId
      );
      userData.tests.push({
        name: "Vergence Test",
        data: userVergenceData !== undefined ? userVergenceData.data : []
      });
    }
    setChartSeries(userData);
  };

  return (
    <Container fluid className="main-content-container px-4 pb-4 pt-5">
      {chartSeries && (
        <Row className="page-header py-4">
          <Col sm="12" md="6" lg="4">
            <Charts
              ref={testChartRef}
              options={{
                ...opt,
                title: { text: chartSeries.name },
                tooltip: {
                  ...opt.tooltip,
                  y: {
                    ...opt.tooltip.y,
                    formatter: function(
                      value,
                      { series, seriesIndex, dataPointIndex, w }
                    ) {
                      return `${value}%`;
                    }
                  }
                }
              }}
              series={chartSeries.tests}
              type="line"
              height={700}
              width={"100%"}
            />
          </Col>
          <Col sm="12" md="6" lg="8">
            <Row className="page-header py-4">
              <h4>Reading tests</h4>
              <Col sm="12" md="6" lg="12">
                <Table striped bordered hover responsive>
                  <thead>
                    <tr className="text-center">
                      <th colSpan={chartSeries.tests[0].data.length + 1}>
                        Test results
                      </th>
                      <th colSpan={chartSeries.tests[0].data.length}>
                        Improvement
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-center">
                      <th>Date</th>
                      {chartSeries.tests[0].data.map((row, indx) => {
                        return <th key={indx}>w{moment(row[0]).isoWeek()}</th>;
                      })}
                      {chartSeries.tests[0].data.map((row, indx) => {
                        return (
                          indx > 0 && (
                            <th key={indx}>w{moment(row[0]).isoWeek()}</th>
                          )
                        );
                      })}
                    </tr>
                    <tr className="text-center">
                      <th>Letters</th>
                      {chartSeries.tests[0].data.map((row, indx) => {
                        return (
                          <td key={indx}>
                            {chartSeries.testsScore[indx].letters}
                          </td>
                        );
                      })}
                      {chartSeries.tests[0].data.map(
                        (row, indx) => indx > 0 && <td key={indx}>{row[1]}%</td>
                      )}
                    </tr>
                    <tr className="text-center">
                      <th>Words</th>
                      {chartSeries.tests[0].data.map((row, indx) => {
                        return (
                          <td key={indx}>
                            {chartSeries.testsScore[indx].words}
                          </td>
                        );
                      })}
                      {chartSeries.tests[1].data.map(
                        (row, indx) => indx > 0 && <td key={indx}>{row[1]}%</td>
                      )}
                    </tr>
                    <tr className="text-center">
                      <th>Sentences</th>
                      {chartSeries.tests[0].data.map((row, indx) => {
                        return (
                          <td key={indx}>
                            {chartSeries.testsScore[indx].sentences}
                          </td>
                        );
                      })}
                      {chartSeries.tests[2].data.map(
                        (row, indx) => indx > 0 && <td key={indx}>{row[1]}%</td>
                      )}
                    </tr>
                    {scheduledTests.map(element => {
                      return element.map((test, indx) => {
                        if (test.userId === chartSeries.userId) {
                          if (test.testName === "Reading test") {
                            return (
                              <tr key={indx} className="text-center ">
                                <td
                                  colSpan={
                                    chartSeries.tests[0].data.length * 2 + 1
                                  }
                                  className="bg-nt"
                                >
                                  Next test &nbsp; &nbsp;
                                  {`  ${test.nextTest}`}
                                </td>
                              </tr>
                            );
                          }
                        }
                      });
                    })}
                  </tbody>
                </Table>
                <h4>Vergence test</h4>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr className="text-center">
                      <th colSpan={chartSeries.tests[3].data.length + 1}>
                        Test results
                      </th>
                      <th colSpan={chartSeries.tests[3].data.length}>
                        Improvement
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-center">
                      <th>Date</th>
                      {ansrDatesForChart.map(row => {
                        if (row.userId === chartSeries.userId) {
                          return row.dates.map((date, indx) => (
                            <th key={indx}>w{moment(date).isoWeek()}</th>
                          ));
                        }
                      })}
                      {ansrDatesForChart.map(row => {
                        if (row.userId === chartSeries.userId) {
                          return row.dates.map((date, indx) => {
                            return (
                              indx > 0 && (
                                <th key={indx}>w{moment(date).isoWeek()}</th>
                              )
                            );
                          });
                        }
                      })}
                    </tr>
                    <tr className="text-center">
                      <th>Vergence</th>
                      {ansrDatesForChart.map(row => {
                        if (row.userId === chartSeries.userId) {
                          return row.total.map((num, indx) => {
                            return <td key={indx}>{num}</td>;
                          });
                        }
                      })}
                      {chartSeries.tests[3] &&
                        chartSeries.tests[3].data.length > 0 &&
                        chartSeries.tests[3].data.map(
                          (row, indx) =>
                            indx > 0 && <td key={indx}>{row[1]}%</td>
                        )}
                    </tr>
                    {scheduledTests.map(element => {
                      return element.map((test, indx) => {
                        if (test.userId === chartSeries.userId) {
                          if (test.testName === "Vergence Test") {
                            return (
                              <tr key={indx} className="text-center">
                                <td
                                  colSpan={
                                    chartSeries.tests[3].data.length * 2 + 1
                                  }
                                  className="bg-nt"
                                >
                                  Next test &nbsp; &nbsp;
                                  {`  ${test.nextTest}`}
                                </td>
                              </tr>
                            );
                          }
                        }
                      });
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Container>
  );
}

export default StudentTestsChart;
